import { getAuth } from "firebase/auth";

interface RenderBody {
	/** URL a convertir a `pdf` o `image` */
	url: `https://${string}`;
	/** Variables que se inyectarán en la variable window */
	window: { key: string; value: string }[];
	/** Nombre del archivo a generar */
	filename: `${string}.${"pdf" | "png"}`;
	/** Función en string (será llamada desde el dev console) que debe de ser `truly` para que continue el proceso de conversion. Ej. waitFor = "window.myapp.isReady" */
	waitFor?: string;
	/** Tamaño de la ventana */
	viewport?: `${number}x${number}`;
	/** Tiempo de espera en milisegundos luego de finalizar la carga de la página. Esto puede servir para dejar que terminen de cargar las imagenes. No debe de ser mayor a 10s */
	timeout?: number;
	/** Firebase Token */
	token?: string;
	skipToken?: boolean;
}
export class Print {
	downloadBlob(blob: Blob | string, filename?: string) {
		const link = document.createElement("a");
		link.href = typeof blob === "string" ? blob : URL.createObjectURL(blob);
		filename && (link.download = filename);
		link.target = "_blank";
		link.click();
	}
	async chrome(type: "pdf" | "image", body: RenderBody, lang = "es"): Promise<Blob | undefined> {
		let idToken = await getAuth().currentUser!.getIdToken();
		body.token = idToken;
		let p = await fetch(`${process.env.RENDER_URL}/v1/chrome/${type}`, {
			headers: {
				Accept: "*/*",
				Authorization: `bearer ${idToken}`,
				"content-type": "application/json",
				"cache-control": "no-cache",
				pragma: "no-cache",
				"x-lang": lang
			},
			method: "POST",
			body: JSON.stringify(body),
			mode: "cors"
		});
		if (p.status !== 200) {
			return undefined;
		}
		return p.blob();
	}
}
